import { useTranslations } from 'next-intl'

export const NoFAQ = () => {
  const t = useTranslations('faq')

  return (
    <div className="typo-body1 flex h-45 items-center justify-center text-center whitespace-break-spaces text-gray-400">
      {t('search_result.empty.description')}
    </div>
  )
}
